
export { default as isEmpty } from "./isEmpty.js"